/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Internal API
 * OpenAPI spec version: v1
 */
import {
  useMutation,
  useQuery
} from '@tanstack/vue-query';
import type {
  DataTag,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationReturnType,
  UseQueryOptions,
  UseQueryReturnType
} from '@tanstack/vue-query';

import {
  toValue,
  unref
} from 'vue';
import type {
  MaybeRefOrGetter
} from 'vue';

import type {
  AiSkill,
  AiSkillRequestInput,
  ListAiSkillsParams,
  PaginatedAiSkills,
  SchemaValidationErrorResponse
} from '../../models';

import { axiosClient } from '../../../internalAxiosClient.ts';
import type { ErrorType } from '../../../internalAxiosClient.ts';




/**
 * @summary Create AI Skill
 */
export const createAiSkill = (
    aiSkillRequestInput: MaybeRefOrGetter<AiSkillRequestInput>,
 signal?: AbortSignal
) => {
      aiSkillRequestInput = toValue(aiSkillRequestInput);

      return axiosClient<AiSkill>(
      {url: `/ai/skills`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: aiSkillRequestInput, signal
    },
      );
    }




export const getCreateAiSkillMutationKey = () => ['createAiSkill'] as const;

export const getCreateAiSkillMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createAiSkill>>, TError,CreateAiSkillMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createAiSkill>>, TError,CreateAiSkillMutationVariables, TContext> => {

const mutationKey = getCreateAiSkillMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createAiSkill>>, CreateAiSkillMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  createAiSkill(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateAiSkillMutationResult = NonNullable<Awaited<ReturnType<typeof createAiSkill>>>
    export type CreateAiSkillMutationBody = AiSkillRequestInput
    export type CreateAiSkillMutationError = ErrorType<SchemaValidationErrorResponse | void>
    export type CreateAiSkillMutationVariables = {data: AiSkillRequestInput}

    /**
 * @summary Create AI Skill
 */
export const useCreateAiSkill = <TError = ErrorType<SchemaValidationErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createAiSkill>>, TError,CreateAiSkillMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof createAiSkill>>,
        TError,
        CreateAiSkillMutationVariables,
        TContext
      > => {
      return useMutation(getCreateAiSkillMutationOptions(options), queryClient);
    }
    /**
 * @summary List of AI Skills
 */
export const listAiSkills = (
    params?: MaybeRefOrGetter<ListAiSkillsParams>,
 signal?: AbortSignal
) => {
      params = toValue(params);

      return axiosClient<PaginatedAiSkills>(
      {url: `/ai/skills`, method: 'GET',
        params, signal
    },
      );
    }




export const getListAiSkillsQueryKey = (params?: MaybeRefOrGetter<ListAiSkillsParams>,) => {
    return [
    'ai','skills', ...(params ? [params] : [])
    ] as const;
    }


export const getListAiSkillsQueryOptions = <TData = Awaited<ReturnType<typeof listAiSkills>>, TError = ErrorType<SchemaValidationErrorResponse>>(params?: MaybeRefOrGetter<ListAiSkillsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAiSkills>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getListAiSkillsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listAiSkills>>> = ({ signal }) => listAiSkills(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listAiSkills>>, TError, TData>
}

export type ListAiSkillsQueryResult = NonNullable<Awaited<ReturnType<typeof listAiSkills>>>
export type ListAiSkillsQueryError = ErrorType<SchemaValidationErrorResponse>


/**
 * @summary List of AI Skills
 */

export function useListAiSkills<TData = Awaited<ReturnType<typeof listAiSkills>>, TError = ErrorType<SchemaValidationErrorResponse>>(
 params?: MaybeRefOrGetter<ListAiSkillsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAiSkills>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListAiSkillsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Delete AI Skill
 */
export const deleteAiSkill = (
    id: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      id = toValue(id);

      return axiosClient<void>(
      {url: `/ai/skills/${id}`, method: 'DELETE', signal
    },
      );
    }




export const getDeleteAiSkillMutationKey = () => ['deleteAiSkill'] as const;

export const getDeleteAiSkillMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAiSkill>>, TError,DeleteAiSkillMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteAiSkill>>, TError,DeleteAiSkillMutationVariables, TContext> => {

const mutationKey = getDeleteAiSkillMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteAiSkill>>, DeleteAiSkillMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  deleteAiSkill(id,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteAiSkillMutationResult = NonNullable<Awaited<ReturnType<typeof deleteAiSkill>>>

    export type DeleteAiSkillMutationError = ErrorType<SchemaValidationErrorResponse | void>
    export type DeleteAiSkillMutationVariables = {id: string}

    /**
 * @summary Delete AI Skill
 */
export const useDeleteAiSkill = <TError = ErrorType<SchemaValidationErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAiSkill>>, TError,DeleteAiSkillMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof deleteAiSkill>>,
        TError,
        DeleteAiSkillMutationVariables,
        TContext
      > => {
      return useMutation(getDeleteAiSkillMutationOptions(options), queryClient);
    }
